import { render, staticRenderFns } from "./house-contract.html?vue&type=template&id=28d60df4&scoped=true&external"
import script from "./house-contract.js?vue&type=script&lang=js&external"
export * from "./house-contract.js?vue&type=script&lang=js&external"
import style0 from "./house-contract.scss?vue&type=style&index=0&id=28d60df4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d60df4",
  null
  
)

export default component.exports